import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import WidgetAllListWrap from '../../views/widget/all/WidgetAllListWrap';

const WidgetAllList = () => {
  return (
    <PageTemplate pageName={WIDGET_PAGE_NAME.WIDGET_ALL_LIST}>
      <WidgetAllListWrap />
    </PageTemplate>
  );
};

export default WidgetAllList;
